// Purchases, as the sales webhook sends them and as the chat and the panel show them

// Room event attributes are strings, so lists travel as JSON
export const parseProducts = (value) => {
  try {
    const list = JSON.parse(value);
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

// A purchase reaches the room as an `app:PURCHASE` event once the panel lets it through
// (or once nobody stopped it during the review window)
export const purchaseFromEvent = ({ attributes, sendTime }) => ({
  type: 'PURCHASE',
  id: attributes.id,
  nickname: attributes.nickname,
  amount: Number(attributes.amount),
  photo: attributes.photo,
  products: attributes.products ? parseProducts(attributes.products) : [],
  sendTime: attributes.sendTime || sendTime,
});

// A purchase already on screen is replaced by a fresh copy (the panel took its photo off)
export const upsertItem = (items, item, max) =>
  items.some(({ id }) => id === item.id)
    ? items.map((current) => (current.id === item.id ? { ...current, ...item } : current))
    : [...items, item].slice(-max);

// 2× Whey Protein 2lb · 1× Shaker
export const productsLabel = (products = []) => products.map(({ qty, name }) => `${qty}× ${name}`).join(' · ');
